import * as angular from 'angular';
import { ModeCommonConfigsModule } from './configs';
import { ModeCommonConstantsModule } from './constants';

/**
 * Mode Common
 *
 * Common configs, constants, decorators etc to be shared
 * between multiple applications
 */
export const ModeCommonModule = angular.module('mode.common', [
  ModeCommonConfigsModule,
  ModeCommonConstantsModule,
]).name;
